import React from 'react';

const ProductLoadingRow = () => {
    return (
        <tr>
          <td className="text-left py-3">
              <div className="animate-pulse">
                  <div className="h-2 w-3/4 bg-gray-300 rounded-md"></div>
              </div>
          </td>
          <td className="px-3 py-3 animate-pulse">
              <div className="h-2 w-full rounded-md bg-gray-300"></div>
          </td>
          <td className="px-3 py-3 animate-pulse">
            <div className="h-2 w-full rounded-md bg-gray-300"></div>
          </td>
        </tr>
      );
}

export default ProductLoadingRow;